import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { MOBILE_SHELL_QUERY } from '../../hooks/useIsMobileShell';
import ToastAlert from '../alert/ToastAlert';

export default function PageScaffold(props) {
    return (
        
        <Box 
            sx={{ 
                width: '100%', 
                minWidth: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                overflow: 'hidden',
                // Shell mobile: `hidden` quebraria o `position: sticky` do topo das listagens
                // (ver DefaultTable); `clip` corta igual sem criar contêiner de rolagem.
                // `allowBleed`: telas mobile com margem negativa (chips/barra de busca até a borda da tela).
                [`@media ${MOBILE_SHELL_QUERY}`]: props.allowBleed ? { overflow: 'visible' } : { '@supports (overflow: clip)': { overflow: 'clip' } },
                backgroundColor: 'transparent',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1
            }}
        >   
        
            {props.children}
            <Snackbar
                open={props.openSnackbar}
                autoHideDuration={props.autoHideDuration || 2800}
                onClose={() => props.setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                data-testid="snackbar"
            >
                <ToastAlert severity={props.severity}>
                    {props.message}
                </ToastAlert>
            </Snackbar>
        </Box>
    )
}